(function () {
  var videos = Array.prototype.slice.call(document.querySelectorAll('video[data-video-sources]'));
  if (!videos.length) return;

  function parseSources(video) {
    try {
      return JSON.parse(decodeURIComponent(video.dataset.videoSources || '[]'));
    } catch (error) {
      return [];
    }
  }

  function hydrateVideo(video) {
    if (video.dataset.videoHydrated === 'true') return;
    var sources = parseSources(video);
    if (!sources.length) return;

    sources.forEach(function (sourceData) {
      if (!sourceData.src) return;
      var source = document.createElement('source');
      source.src = sourceData.src;
      if (sourceData.type) source.type = sourceData.type;
      video.appendChild(source);
    });

    video.dataset.videoHydrated = 'true';
    video.load();

    if (video.autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.play().catch(function () {});
    }
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach(hydrateVideo);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        hydrateVideo(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '600px 0px' }
  );

  videos.forEach(function (video) {
    observer.observe(video);
  });
})();
